import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["language-code", "chat-title", "chat-icon", "agent-id", "intent"]

import { onMounted, ref, nextTick } from 'vue';
  import { settingStore } from '@/stores';
  import i18n from '@/i18n';

  export type ConcatStyle = {
    width: string;
    height: string;
    right: string;
  }

  interface Emits {
    (event: 'loaded', style: ConcatStyle): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  emits: ["loaded"],
  setup(__props, { emit: emits }: { emit: ({
    (event: 'loaded', style: ConcatStyle): void;
  }), expose: any, slots: any, attrs: any }) {

  const clientId = ref();
  const intent = ref();
  const chatTitle = ref();
  

  const init = async () => {
    await settingStore.tryFetchData();
    clientId.value = settingStore.data.google_dialog_config_vars?.client_id;
    intent.value = settingStore.data.google_dialog_config_vars?.intent;
    chatTitle.value = settingStore.data.google_dialog_config_vars?.chat_title;

    await nextTick();
    const dfMessenger = document.querySelector('df-messenger');
    // 获取dfMessenger的定位和大小，自定义这个太麻烦了，虽然能写死，但可以动态获取就动态获取
    if (dfMessenger && dfMessenger.shadowRoot) {
      const dfMessengerWrapper = dfMessenger.shadowRoot.querySelector('.df-messenger-wrapper');
      const button = dfMessenger.shadowRoot.querySelector('#widgetIcon');
      const react = button?.getBoundingClientRect();
      const style: ConcatStyle = {
        width: `${react?.width}px`,
        height: `${react?.height}px`,
        right: dfMessengerWrapper && window.getComputedStyle(dfMessengerWrapper).right || '20px'
      };
      emits('loaded', style);
    }
  };

  onMounted(init);

return (_ctx: any,_cache: any) => {
  return (clientId.value)
    ? (_openBlock(), _createElementBlock("df-messenger", {
        key: 0,
        "language-code": _unref(i18n).global.locale.value,
        "chat-title": chatTitle.value,
        "chat-icon": require('@/assets/icon/icon-contact.png'),
        "agent-id": clientId.value,
        intent: intent.value
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})